import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { LazyModule } from 'owa-bundling';
import AtMentionPickerPlugin from './plugin/AtMentionPickerPlugin';
import { PluginEventType } from 'roosterjs-editor-types';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "HtmlEditor" */ './lazyIndex'));
export type LazyAtMentionsPickerPlugin = LazyPlugin<AtMentionPickerPlugin>;

export let LazyAtMentionsPickerPluginClass = createLazyPlugin(
    lazyModule,
    m => m.AtMentionPickerPlugin,
    'AtMentionsPicker',
    event => event.eventType == PluginEventType.EditorReady
);
